import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  getProfileDetails: [],
  userProfileList: [],
  dayWeekandHoursList: [],
  businessUnitList: [],
  groupsList: [],
  designationList: [],
  roleList: [],
  UserList: [],
  dropdown: [],
  profileLoader: true,
  userLoader: true,
  filterLoader: true,
  alluserdata: [],
  userDeviceDetailList: [],
  userListCont: [],
  alluserLoader: true,
  Editor: false,
  requestUserDetails: [],
  requestUserDetailsLoader: true,
  requestUserDetailscount: 0,
  isEnabledflag: false,
  message: "",
  AllUser: [],
  AllUserLoader: false,
  alluserdataauthorize: [],
  bulkUpload: [],
  bulkLoad: true,
  reportingWiseList: [],
  isLoadingReportingWiseList: true,
  workingHour: [],
  userDetailsTab: "1",
  allUserOverTime: [],
  isLoadingAllUserOvertime: false,
  isUserUpload:false,
  assetUserStatusData:[],
  isInactivateUserUpload:false,
  inactiveUserStatusLogData:[]
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_PROFILE_DETAIL:
      return {
        ...state,
        userProfileList: action.data.list.userProfileList[0],
        dayWeekandHoursList: action.data.list.dayWeekandHoursList,
        designationList: action.data.list.designationList,
        businessUnitList: action.data.list.businessUnitList,
        groupsList: action.data.list.groupsList,
        roleList: action.data.list.roleList,
        getProfileDetails: action.data.list,
        profileLoader: false,
      }
    case types.FAILD_PROFILE_DETAIL:
      return {
        ...state,
        getProfileDetails: [],
        userProfileList: [],
        dayWeekandHoursList: [],
        businessUnitList: [],
        groupsList: [],
        designationList: [],
        roleList: [],
        profileLoader: false,
      }
    case types.GET_USER_LIST:
      return {
        ...state,
        UserList: action.data.list,
        userLoader: false,
      }
    case types.FAILD_GET_USER_LIST:
      return {
        ...state,
        // UserList: [],
        userLoader: false,
      }
    case types.GET_REPORTING_WISE_LIST:
      return {
        ...state,
        reportingWiseList: action.data.list,
        isLoadingReportingWiseList: false
      }
    case types.FAILD_REPORTING_WISE_LIST:
      return {
        ...state,
        reportingWiseList: [],
        isLoadingReportingWiseList: false
      }
    case types.GET_FILTER:
      return {
        ...state,
        dropdown: action.data.list,
        filterLoader: false,
      }
    case types.FAILD_GET_FILTER:
      return {
        ...state,
        dropdown: [],
        filterLoader: true,
      }
    case types.GET_ALL_USER:
      var data = [];
      var tableBody = [];
      var tabledata = {}
      var flag = false;
      var Message = ""
      if (action.data.list.userListCont.length > 0) {
        //console.log("card", action.data.list.userListCont)
        if (window.globalConfig.isEnterprize) {
          data = [
            { name: 'Total User', unitBefore: action.data.list.userListCont[0].totalUser, unitAfter: '', color: '#00AFEF', icon: 1, background: 'rgba(87,113,219,0.05)', redirect: "1" },
            { name: 'Active User', unitBefore: action.data.list.userListCont[0].activeUser, unitAfter: '', color: '#00AFEF', icon: 2, background: 'rgba(87,113,219,0.05)', redirect: "1" },
            { name: 'Users with Agent', unitBefore: action.data.list.userListCont[0].userWithAgent, unitAfter: '', color: '#00AFEF', icon: 2, background: 'rgba(87,113,219,0.05)', redirect: "1" },
            { name: 'TrakZoLite User', unitBefore: action.data.list.userListCont[0].trakzoLiteUser, unitAfter: '', color: '#00AFEF', icon: 2, background: 'rgba(87,113,219,0.05)', redirect: "3" },
            { name: 'Inactive User', unitBefore: action.data.list.userListCont[0].inactiveUser, unitAfter: '', color: '#00AFEF', icon: 3, background: 'rgba(87,113,219,0.05)', redirect: "0" },
          ]
        } else {
          data = [
            { name: 'Total User', unitBefore: action.data.list.userListCont[0].totalUser, unitAfter: '', color: '#00AFEF', icon: 1, background: 'rgba(87,113,219,0.05)', redirect: "1" },
            { name: 'Active User', unitBefore: action.data.list.userListCont[0].activeUser, unitAfter: '', color: '#00AFEF', icon: 2, background: 'rgba(87,113,219,0.05)', redirect: "1" },
            { name: 'Users with Agent', unitBefore: action.data.list.userListCont[0].userWithAgent, unitAfter: '', color: '#00AFEF', icon: 2, background: 'rgba(87,113,219,0.05)', redirect: "1" },
            { name: 'TrakZoLite User', unitBefore: action.data.list.userListCont[0].trakzoLiteUser, unitAfter: '', color: '#00AFEF', icon: 2, background: 'rgba(87,113,219,0.05)', redirect: "3" },
            { name: 'Inactive User', unitBefore: action.data.list.userListCont[0].inactiveUser, unitAfter: '', color: '#00AFEF', icon: 3, background: 'rgba(87,113,219,0.05)', redirect: "0" },
          ]
        }
        flag = action.data.list.userListCont[0].isEnable
        Message = action.data.list.userListCont[0].message
      }
      if (action.data.list.userList.length > 0) {
        var deviceDetails = [];
        
        var lastDataDevice=[]
        action.data.list.userList.map(user => {
          var userDevice = []
          action.data.list.userDeviceDetailList.filter(i => i.id == user.userId).map(device => {
            userDevice.push(device.systemname)
            
            if(device.lastDataOrder==1){
              lastDataDevice.push({lastDataReceivedOn:device.lastDataReceived,userAgentVersion:device.version,userId:user.userId})
            }
          });
          deviceDetails.push({ id: user.userId, device: userDevice.join(",") })
        });
       // console.log("lastDataDevice", lastDataDevice)
        action.data.list.userList.map((value) => {
          tableBody.push({
            "userName": value.userName,
            "email": value.email,
            "empCode": value.empCode,
            "trakZoLite": value.trakZoLite,
            "action": { userid: value.userId, userName: value.userName, button: true, editbutton: true, deletebutton: true },
            "roleName": value.roleName,
            "profileImage": value.profileImage,
            "agentInstalled": value.agentInstalled,
            "deviceCount": value.deviceCount,
            "profileCal": isNaN(value.profileCal) ? "-" : parseInt(value.profileCal),
            "userid": value.userId,
            "avatar": value.profileImage,
            "businessUnit": value.businessUnit,
            "department": value.department,
            "designation": value.designation ? value.designation : '',
            "location": value.location ? value.location : '',
            "mobile": value.mobile,
            "team": value.team ? value.team : '-',
            "trakZoRights": value.trakZoRights,
            "jobRole": value.role,
            "workingHours": value.workingHours,
            "deactivationDate":value.deactivationDate!=undefined?value.deactivationDate:"",
            "systemName": deviceDetails.filter(i => i.id == value.userId).map(item => {
              return item.device
            }).join(",") ? deviceDetails.filter(i => i.id == value.userId).map(item => {
              return item.device
            }).join(",") : '-',
           "lastDataDetails":lastDataDevice.filter(i => i.userId == value.userId)
          })
        })

      }
      //console.log("tableBody",tableBody)
      //console.log("check", action.data.list.userDeviceDetailList)
      return {
        ...state,
        alluserdata: tableBody,
        userDeviceDetailList: action.data.list.userDeviceDetailList,
        userListCont: data,
        alluserLoader: false,
        isEnabledflag: flag,
        message: Message
      }
    case types.FAILD_GET_ALL_USER:
      return {
        ...state,
        alluserdata: [],
        userListCont: [],
        alluserLoader: false,
        isEnabledflag: false,
        message: ""
      }
    case types.GET_UNAUTHORIZED_USER_LIST:

      var tableBody = [];

      if (action.data.list.length > 0) {
        action.data.list.map((value) => {
          tableBody.push({
            "id": value.id,
            "systemName": value.systemName,
            "loginName": value.loginName,
            "accountName": value.accountName,
            "macAddress": value.macAddress.toLowerCase()!="null"?value.macAddress:"-",
            "ipAddress": value.ipAddress,
            "agentVersion": value.agentVersion,
            "agentStatus": value.agentStatus,
            "lastDataReceived":value.lastDataReceivedOn
          })
        })

      }
      return {
        ...state,
        alluserdataauthorize: tableBody,
        alluserLoader: false,
      }
    case types.FAILD_UNAUTHORIZED_USER_LIST:
      return {
        ...state,
        alluserdataauthorize: [],
        alluserLoader: false,
      }
    case types.USER_LIST_LODE:
      return {
        ...state,
        alluserLoader: true,
      }
    case types.USER_LOADER:
      return {
        ...state,
        alluserLoader: true,
        profileLoader: true,
        userLoader: true,
        filterLoader: true,
      }
    case types.EDITOR: {
      return {
        ...state,
        Editor: action.data
      }
    }
    case types.GET_PENDING_TEAM_REQUEST:
      return {
        ...state,
        requestUserDetails: action.data.list,
        requestUserDetailscount: action.data.list.length,
        requestUserDetailsLoader: false,
      }
    case types.FAILED_PENDING_TEAM_REQUEST: {
      return {
        ...state,
        requestUserDetails: [],
        requestUserDetailscount: 0,
        requestUserDetailsLoader: true,
      }
    }
    case types.GET_ALL_USER_LIST:
      return {
        ...state,
        AllUser: action.data.list,
        AllUserLoader: false,
      }
    case types.SUCCESS_ALL_USER_LIST_OVERTIME:
      return {
        ...state,
        allUserOverTime: action.data.list,
        isLoadingAllUserOvertime: false,
      }
    case types.FAILD_ALL_USER_LIST_OVERTIME:
      return {
        ...state,
        allUserOverTime: [],
        isLoadingAllUserOvertime: false,
      }
    case types.FETCH_ALL_USER_LIST_OVERTIME:
      return {
        ...state,
        allUserOverTime: [],
        isLoadingAllUserOvertime: true,
      }
    case types.FAILD_ALL_GET_USER_LIST: {
      return {
        ...state,
        AllUser: [],
        AllUserLoader: false,
      }
    }
    case types.DELETE_TABLE: {
      var data = state.alluserdataauthorize.filter(el => el.id != action.data)
      return {
        ...state,
        alluserdataauthorize: data,
      }
    }
    case types.SUCCESS_GET_BULK_UPLOAD_LOG:
      return {
        ...state,
        bulkUpload: action.data,
        bulkLoad: false
      }
    case types.FAILED_GET_BULK_UPLOAD_LOG: {
      return {
        ...state,
        bulkUpload: [],
        bulkLoad: false
      }
    }
    case types.SUCCESS_WORKINGHOUR_PROFILE:
      return {
        ...state,
        workingHour: action.data
      }
    case types.FAILED_WORKINGHOUR_PROFILE: {
      return {
        ...state,
        workingHour: []
      }
    }
    case types.LODEAR_BULK_UPLOAD_LOG: {
      var data = state.alluserdataauthorize.filter(el => el.id != action.data)
      return {
        ...state,
        bulkUpload: [],
        bulkLoad: true
      }
    }
    case types.REMOVE_DEVICE_COUNT: {
      var userDeviceDetailList = state.userDeviceDetailList.filter(i => i.agentUserID != action.data.id)
      var data = state.alluserdata.map(i => {
        if (action.data.userid == i.userid) {
          var value = { ...i }
          value.deviceCount = value.deviceCount - 1
          return { ...value }
        } else {
          return { ...i }
        }
      })
      return {
        ...state,
        alluserdata: data,
        userDeviceDetailList: userDeviceDetailList
      }
    }
    case types.UPDATE_USER_LIST_TAB: {
      return {
        ...state,
        userDetailsTab: action.data
      }
    }
    case types.LODEAR_BULKUSER_UPLOAD_LOG:
      return {
        ...state,
        isUserUpload:true,
      }
    case types.SUCCESS_GETUSER_BULK_UPLOAD_LOG:
      return {
        ...state,
        isUserUpload:false,
        assetUserStatusData:action.data
      }
    case types.FAILED_GETUSER_BULK_UPLOAD_LOG: {
      return {
        ...state,
        isUserUpload:false,
        assetUserStatusData:[]
      }
    }
    case types.LODEAR_BULKINACTIVATEUSER_UPLOAD_LOG:
      return {
        ...state,
        isInactivateUserUpload:true,
      }
    case types.SUCCESS_GETINACTIVATEUSER_BULK_UPLOAD_LOG:
      return {
        ...state,
        isInactivateUserUpload:false,
        inactiveUserStatusLogData:action.data
      }
    case types.FAILED_GETINACTIVATEUSER_BULK_UPLOAD_LOG: {
      return {
        ...state,
        isInactivateUserUpload:false,
        inactiveUserStatusLogData:[]
      }
    }
    default:
      return state
  }
}
export default reducer